import { ApiResponse } from "lib/Api";
import { notificationStore, sessionStore } from "./store";

export async function call<T extends ApiResponse>(
  promise: Promise<T>,
  ignoreErrorCodes: number[] = [],
) {
  const response = await promise;

  switch (response.code) {
    case 200:
      // noop
      break;
    case 401:
      sessionStore.requireLogin();
      break;
    case 403:
      notificationStore.notifyError("Forbidden");
      break;
    default:
      if (response.code == null || !ignoreErrorCodes.includes(response.code)) {
        if (response.body.name === "UnexpectedResponseError") {
          notificationStore.notifyError(response.body.response.statusText);
        } else if (response.body.message != null) {
          notificationStore.notifyError(response.body.message);
        } else {
          notificationStore.notifyError("Unexpected Response Error");
        }
      }
      break;
  }

  return response;
}
